<template>
</template>
<script>
    export default {
        name: "HtmlElement",
        data() {
            return {
                elementType: 'html',
            }
        },
    }
</script>
